import { Entry } from '../Entry'

export function Entry20240605() {
  return (
    <Entry title="05/06/2024 - v3.7.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15872/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
